import { useEffect, useState } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimationControls } from "framer-motion";
import { Helmet } from 'react-helmet';

import { faBookOpenReader, faChevronDown, faComments, faGift, faHandHolding, faHandshake, faList, faMagnifyingGlassArrowRight, faPeopleGroup, faPerson, faPhone, faRocket, faTags } from '@fortawesome/free-solid-svg-icons'


import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import CTAButton from '../../components/CTAButton'
import AnimatedQuote from '../../components/AnimatedQuote'

import { lP, oPU, boxvar1, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2_1l, boxvar2_2l, boxvar2_3l } from '../../core.js'

import head_aiexpert from '../../assets/pictures/sectionimages/head_aiexpert-cut_compressed.webp'
import iphone_appdev from '../../assets/pictures/sectionimages/iphone_appdev-cut_compressed.webp'
import iphonecam_contentcreator from '../../assets/pictures/sectionimages/iphonecam_contentcreator-cut_compressed.webp'
import macbook_webdev from '../../assets/pictures/sectionimages/macbook_webdev-cut_compressed.webp'
import rack_serverhosting from '../../assets/pictures/sectionimages/rack_serverhosting-cut_compressed.webp'
import cam_photography from '../../assets/pictures/sectionimages/cam_photography-cut_compressed.webp'

import testimonial_klaus from '../../assets/pictures/testimonials/testimonial_klaus.webp'
import testimonial_manuela from '../../assets/pictures/testimonials/testimonial_manuela.webp'
import testimonial_joely from '../../assets/pictures/testimonials/testimonial_joely.webp'

import './Home.css'
import './MHome.css'
import { ParallaxImage, ParallaxReveal } from '../../components/ParallaxReveal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TrackedSection from '../../components/TrackedSection';
import BottomServiceBanner from '../../components/BottomServiceBanner';
import useProgressiveHeroBg from '../../hooks/useProgressiveHeroBg';


const scrolldowniconanim = {
    idle: {
        y: [0, 6, 0],
        scale: 1,
        transition: {
            duration: 1.5,
            repeat: Infinity,
            ease: "easeOut"
        }
    },
    hover: {
        y: [0, 3, 0],
        scale: 1.2,
        transition: {
            duration: 1.0,
            repeat: Infinity,
            ease: "easeInOut",
        },
    },
}

export default function Home() {

    const controls = useAnimationControls();
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1380);

    useEffect(() => {
        controls.start("idle");
    }, [controls]);

    useEffect(() => {
        const onResize = () => setIsMobileView(window.innerWidth <= 1380);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    const motionVar1 = isMobileView ? boxvar2_1 : boxvar2_1l;
    const motionVar2 = isMobileView ? boxvar2_2 : boxvar2_2l;
    const motionVar3 = isMobileView ? boxvar2_3 : boxvar2_3l;


    useProgressiveHeroBg('sec_start--home');

    const [banner, setBanner] = useState({ show: false, message: "", cta: "", ctalink: "" });

    const handleShowBanner = (sectionId) => {
        const messages = {
            "1-services-webdev": {
                message: "Gefällt dir was du siehst? Erhalte auch du eine neue Webseite!",
                cta: "Jetzt modernisieren",
                ctalink: "/services/webdev",
            },
            "1-services-appdev": {
                message: "Eine App fällt nicht weit vom Stamm... oder so xD",
                cta: "Jetzt zur eigenen App",
                ctalink: "/services/appdev",

            },
            "1-services-hosting": {
                message: "We need power!!! Ordentliche Rechenleistung ist wichtiger denn je",
                cta: "Erfahre mehr über Serverhosting",
                ctalink: "/services/hosting",
            },
            "1-services-ai": {
                message: "KI für dein Unternehmen ist einfacher als du denkst und umfasst lange nicht nur ChatGPT und co",
                cta: "Mehr erfahren",
                ctalink: "/services/ai",

            },
            "1-services-socialmedia": {
                message: "Du möchtest auch bei der jungen Zielgruppe ankommen?",
                cta: "Zum ersten eigenen Reel",
                ctalink: "/services/content",

            },
            "1-services-photography": {
                message: "Entdecke jetzt unser Foto und Video Portfolio von bisherigen Events und Aufträgen",
                cta: "Zum Portfolio",
                ctalink: "/services/photos",

            },
        };
        setBanner({ show: true, ...messages[sectionId] });
    };

    const handleCloseBanner = () => setBanner({ show: false, message: "", cta: "" });


    return (
        <div className='mainCon' id='mainCon--home'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>ToNetwork – Web, Apps, KI, Hosting, Media</title>
                <link rel="canonical" href="https://tonetwork.de/" />
                <meta name="description" content="ToNetwork: Webentwicklung, App-Entwicklung, Serverhosting, KI-Beratung und Media aus einer Hand. Dein Partner für die digitale Welt." />
                <meta property="og:title" content="ToNetwork – Dein Partner für das digitale Zeitalter" />
                <meta property="og:description" content="Webentwicklung, Apps, Hosting, KI und Content – alles aus einer Hand bei ToNetwork." />
                <meta property="og:url" content="https://tonetwork.de/" />
            </Helmet>

            <section className='sec_start progressive-hero-bg' id='sec_start--home'>

                <motion.div
                    variants={boxvar1}
                    initial="hidden"
                    exit="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className="start_heading_cont"
                >

                    <AnimatedQuote className='start_quote' text="„Be different. Unleash your creativity.“" />

                    <p className='start_about'>
                        ToNetwork ist dein persönlicher Partner aus dem Allgäu für die digitale Welt.<br />
                        Wir sind Software Entwickler, Content Creator, AI Experten...<br />
                        <br />
                        Und das ganze: <b className='start_about_highlight'>All-in-One</b>
                        {/* <br />
                        Du brauchst nur einen Ansprechpartner – wir kümmern uns um den Rest. */}
                    </p>

                </motion.div>




                <motion.div variants={boxvar3} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>                    <br /><br />
                    <CTAButton className="sec_start_btn" showArrow={false} customIcon={faPhone} iconLeft={true} title={"Kostenloses Erstgespräch"} onclick={() => { oPU('https://calendly.com/tonetworkde-meet/getintouch') }}></CTAButton>
                    <br />
                    <CTAButton className="sec_start_btn sec_start_btn-chat" showArrow={false} lightcta={true} customIcon={faComments} iconLeft={true} title={"Fragen? Chatte mit ToNi"} href={'/chat'}></CTAButton>
                </motion.div>

                <Link smooth to='#sec_next--home--kunden' >
                    {/* <div className='sec_next_icon_div noselect'> */}
                    <motion.div
                        className='sec_next_icon_div noselect'
                        onHoverStart={() => controls.start("hover")}
                        onHoverEnd={() => controls.start("idle")}
                    >
                        <span>Erfahre mehr</span>
                        {/* <motion.div variants={scrolldowniconanim} className='sec_next_icon' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "0px" }}> */}
                        <motion.div
                            variants={scrolldowniconanim}
                            // animate="animate"
                            // whileHover="hover"
                            animate={controls}
                        >
                            <FontAwesomeIcon icon={faChevronDown} className='sec_next_icon_arrow' />
                        </motion.div>
                    </motion.div>
                    {/* </div> */}
                </Link>

            </section>

            <section className='sec_next' id='sec_next--home--kunden'>
                <div className='sec_next_cont'>
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Happy Faces - Warum unsere Kunden bleiben</h2>
                        <p>
                            Wir setzen auf langfristige Kundenbeziehungen und persönliche Betreuung. Lese hier, wie wir unsere Kunden bei ihrer Digitalisierung begleiten.
                        </p>
                    </motion.div>
                    <div className='testimonial_list'>
                        <motion.div variants={motionVar1} id='testimonial_1' className='testimonial_box' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "0px" }}>
                            <span className='testimonial_quote'>"Mit ToNetwork haben wir einen langfristigen Partner für den Bereich Webentwicklung gefunden."</span>
                            <div className='testimonial_person_cont'>
                                <img src={testimonial_klaus} alt='Unser Kunde: Klaus Liepert' />
                                <div className='testimonial_person_text_cont'>
                                    <span className='testimonial_name'>Klaus Liepert</span>
                                    <span className='testimonial_company'>CEO,<br />it.liepert.gmbh</span>
                                </div>
                            </div>
                        </motion.div>

                        {/* <div className='testimonial_box' id='testimonial_2'>
                            <span className='testimonial_quote'>"Für unsere spezielle Anforderung hatte ToNetwork sofort eine passende Lösung."</span>
                            <div className='testimonial_person_cont'>
                                <img src={testimonial_klaus} alt='Unser Kunde: Markus Geske' />
                                <div className='testimonial_person_text_cont'>
                                    <span className='testimonial_name'>Marcus Geske</span>
                                    <span className='testimonial_company'>Technischer Leiter,<br />Stadtwerke Memmingen</span>
                                </div>
                            </div>
                        </div> >*/}

                        <motion.div variants={motionVar2} id='testimonial_3' className='testimonial_box' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "0px" }}>
                            <span className='testimonial_quote'>"Für das Ehrenamt war die Plattform Helferzeit eine echte Erleichterung."</span>
                            <div className='testimonial_person_cont'>
                                <img src={testimonial_manuela} alt='Unsere Kundin: Manuela Walcher' />
                                <div className='testimonial_person_text_cont'>
                                    <span className='testimonial_name'>Manuela Walcher</span>
                                    <span className='testimonial_company'>Projekt Vesperkirche,<br />Diakonie Allgäu</span>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div variants={motionVar3} id='testimonial_4' className='testimonial_box' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "0px" }}>
                            <span className='testimonial_quote'>"Dank der Fotos von David erstrahlen unsere Events in neuem Licht."</span>
                            <div className='testimonial_person_cont'>
                                <img src={testimonial_joely} alt='Unser Kunde: Joely White' />
                                <div className='testimonial_person_text_cont'>
                                    <span className='testimonial_name'>Joely White</span>
                                    <span className='testimonial_company'>Veranstalter,<br />Queerparadise Party</span>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                    <br /><br /><br />
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <p>
                            Erfahre noch mehr über unsere Arbeit im Auftrag unserer Kunden.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={false} customIcon={faBookOpenReader} iconLeft={true} title={"Unsere Kunden"} href={'/projects/?type=kunden'}></CTAButton>
                    </motion.div>
                </div>
            </section >
            <section className='sec_next' id='sec_next--home--leistungen'>
                <div className='sec_next_cont'>
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <h2>Bei uns gibt es Digitalisierung aus einer Hand.</h2>
                        <p>
                            Wir möchten dir einen umfangreichen und maßgeschneiderten Service bieten.<br />
                            Wir gehen direkt auf deine Bedürfnisse ein und zeigen dir neue Wege auf.<br />
                            Dabei sind wir dein Single Point of Contact für Digitalisierung und Media in deinem Unternehmen.<br />
                            Für dich bleiben wir auch nach Abschluss des Projekts als langjähriger Partner an der Seite.
                        </p>
                        <p>
                            Du möchtest gleich wissen, was das kostet? Unsere transparente Preisübersicht zeigt dir alle Pakete – <b>Listenpreise ohne Rabatte</b>, die wir individuell für dich anpassen.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={false} customIcon={faTags} iconLeft={true} title={"Transparente Preise ansehen"} href={'/pricing'}></CTAButton>
                        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                        {/* <CTAButton className="" showArrow={false} customIcon={faHandshake} iconLeft={true} title={"Kontakt aufnehmen"} href={'/support'}></CTAButton> */}
                    </motion.div>
                    <div className='services_list'>

                        <BottomServiceBanner
                            show={banner.show}
                            message={banner.message}
                            cta={banner.cta}
                            ctalink={banner.ctalink}
                            onClose={handleCloseBanner}
                        />

                        <TrackedSection title={'Webentwicklung'} id={'1-services-webdev'} threshold={4000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>

                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/webdev') }} className='noselect'>&lt;Webentwicklung/&gt;</h3>
                                        <h4>Eure Website, die verkauft – modern, schnell, gefunden</h4>
                                        <p>
                                            Vom professionellen Firmenportfolio bis hin zur individuellen Plattformlösung – wir machen deine digitale Präsenz sichtbar und erfolgreich.<br />
                                            Ob modernes CMS oder maßgeschneiderte Self-Coded-Lösung:<br />
                                            <b>Du entscheidest, wir setzen um.</b>
                                            <br />
                                        </p>
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/webdev'}></CTAButton>

                                    </div>
                                    {/* <img src={macbook_webdev} alt='Ein MacBook mit einer Webseite und Code daneben symbolisiert Webentwicklung' /> */}
                                    <ParallaxImage
                                        src={macbook_webdev}
                                        alt='Ein MacBook mit einer Webseite und Code daneben symbolisiert Webentwicklung'
                                        parallaxOffset={150}
                                        mobileparallaxOffset={100}
                                        className=""
                                    />
                                    {/* <img src={macbook_webdev} alt='Ein MacBook mit einer Webseite und Code daneben symbolisiert Webentwicklung' /> */}
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>

                        <TrackedSection title={'Appentwicklung'} id={'1-services-appdev'} threshold={7000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>
                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/appdev') }} className='noselect'>&lt;Appentwicklung/&gt;</h3>
                                        <h4>Eure eigene App – ohne Technik-Kopfschmerzen</h4>
                                        <p>
                                            So einfach wie noch nie – mit uns als erfahrenem Partner an deiner Seite!<br /><br />
                                            Ob Kundenbindung, interne Prozesse oder Speziallösungen: Deine Vision wird zur smarten Anwendung:<br />
                                            <b>intuitiv, performant, zukunftssicher.</b>
                                            <br />
                                            {/* <i>sky is the limit.</i> */}
                                        </p>
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/appdev'}></CTAButton>

                                    </div>
                                    <ParallaxImage
                                        src={iphone_appdev}
                                        alt='Ein iPhone mit einem Layout-Entwurf auf dem Display symbolisiert Appentwicklung'
                                        parallaxOffset={150}
                                        mobileparallaxOffset={80}
                                        className=""
                                    />
                                    {/* <img src={iphone_appdev} alt='Ein iPhone mit einem Layout-Entwurf auf dem Display symbolisiert Appentwicklung' /> */}
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>

                        <TrackedSection title={'Serverhosting'} id={'1-services-hosting'} threshold={5000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>
                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/hosting') }} className='noselect'>&lt;Serverhosting/&gt;</h3>
                                        <h4>Sorgenfreies Hosting – stabil, skalierbar, sicher</h4>
                                        <p>
                                            Jede starke Software braucht eine stabile Grundlage – die passende Hardware.<br />
                                            Wir kümmern uns um zuverlässiges Serverhosting mit hoher Verfügbarkeit, Skalierbarkeit und Sicherheit – damit dein System jederzeit bereit ist.<br />
                                            Wir setzen auf Made in Germany für mehr Datenschutz.
                                            <br />
                                        </p>
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/hosting'}></CTAButton>

                                    </div>
                                    <ParallaxImage
                                        src={rack_serverhosting}
                                        alt='Serverrack-Schrank symbolisiert die Dienstleistung Server Hosting'
                                        parallaxOffset={150}
                                        mobileparallaxOffset={90}
                                        className=""
                                    />
                                    {/* <img src={rack_serverhosting} alt='Serverrack-Schrank symbolisiert die Dienstleistung Server Hosting' /> */}
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>

                        <TrackedSection title={'AI-Expertise'} id={'1-services-ai'} threshold={3000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>
                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/ai') }} className='noselect'>&lt;AI-Expertise/&gt;</h3>
                                        <h4>KI, die euch wirklich Zeit spart</h4>
                                        <p>
                                            Du hast die Daten – wir machen daraus smarte Entscheidungen.<br />
                                            Mit unserer KI-Beratung gewinnst du fundierte Prognosen, Prozessoptimierungen und einen echten Wettbewerbsvorteil.<br />
                                            <b>Effizient, individuell, datengestützt.</b>
                                            <br />
                                        </p>
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/ai'}></CTAButton>

                                    </div>
                                    <ParallaxImage
                                        src={head_aiexpert}
                                        alt='Ein neon-blau leuchtendes Gehirn symbolisiert die Beratung im KI-Umfeld'
                                        parallaxOffset={150}
                                        mobileparallaxOffset={90}
                                        className=""
                                    />
                                    {/* <img src={head_aiexpert} alt='Ein neon-blau leuchtendes Gehirn symbolisiert die Beratung im KI-Umfeld' /> */}
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>

                        <TrackedSection title={'Content-Creator'} id={'1-services-socialmedia'} threshold={4000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>
                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/content') }} className='noselect'>&lt;Content-Creator/&gt;</h3>
                                        <h4>Reichweite statt teurer Werbung</h4>
                                        <p>
                                            Hebe dein Unternehmen mit starkem Social Media Content organischauf das nächste Level – wir zeigen dir, wie’s geht.<br />
                                            Mit gezielter Foto- und Videoproduktion, die deine Zielgruppe wirklich erreicht.
                                            <br />
                                        </p>
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/content'}></CTAButton>

                                    </div>
                                    <ParallaxImage
                                        src={iphonecam_contentcreator}
                                        alt='Ein iPhone mit Videokamera daneben als Symbol für Socialmedia'
                                        parallaxOffset={100}
                                        mobileparallaxOffset={80}
                                        className=""
                                    />
                                    {/* <img src={iphonecam_contentcreator} alt='Ein iPhone mit Videokamera daneben als Symbol für Socialmedia' /> */}
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>

                        <TrackedSection title={'Fotografie'} id={'1-services-photography'} threshold={2000} onTrigger={handleShowBanner}>
                            <ParallaxReveal direction="left" parallaxOffset={0}>
                                <div className='services_box'>
                                    <div className='services_textbox'>
                                        <h3 onClick={() => { lP('/services/photos') }} className='noselect'>&lt;Fotografie/&gt;</h3>
                                        <h4>Bilder, die in Erinnerung bleiben</h4>
                                        <p>
                                            Ob professionelle Businessporträts, Produktshootings oder Events – wir fangen Emotionen und Markenidentität in beeindruckenden Bildern ein.<br />
                                            Für deinen perfekten Auftritt – online wie offline.
                                        </p>
                                        {/* TODO seperate Seite mit Bild-Portfolio / Referenzen */}
                                        <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr dazu"} href={'/services/photos'}></CTAButton>
                                    </div>
                                    <ParallaxImage
                                        src={cam_photography}
                                        alt='Eine professionelle Kamera symbolisiert die Dienstleistung Fotografie'
                                        parallaxOffset={100}
                                        mobileparallaxOffset={80}
                                        className=""
                                    />
                                </div>
                            </ParallaxReveal>
                        </TrackedSection>


                        <br /><br /><br />

                    </div>

                    {/* TODO Viewtime messen und nach wenigen Sekunden ein nicht zu aufdringliches Popup mit Kontakt Button anzeigen */}

                    <br />
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h3>Darf's a bisserl mehr sein?</h3>
                        <p>
                            Du hast große Pläne und suchst einen starken Partner? <br />
                            <b>Wir lieben Herausforderungen!</b><br />
                            Melde dich am besten gleich jetzt mit deinem Vorhaben - auch im Bereich Mikroelektronik - und wir finden gemeinsam die perfekte Lösung für dich.<br />
                        </p>
                        {/* <p>
                        Du möchtest noch mehr über unsere Leistungen und Services erfahren, um dir ein besseres Bild von unserem Unternehmen zu machen?<br />
                        <a href='/support'>Kontaktiere uns am besten gleich</a> und wir stellen uns in einem persönlichen Gespräch bei dir vor. <br />
                        Alternativ kannst du hier vorab noch mehr über die Vorteile erfahren:
                    </p> */}
                        <br />
                        {/* <CTAButton className="" showArrow={false} customIcon={faGift} iconLeft={true} title={"Entdecke unsere Vorteile"} onclick={() => { oPU('/projects/') }}></CTAButton> */}
                        <CTAButton className="" showArrow={false} customIcon={faRocket} iconLeft={true} title={"Jetzt durchstarten"} onclick={() => { oPU('/support') }}></CTAButton>
                    </motion.div>
                </div>
            </section>
            <section className='sec_next' id='sec_next--home--projekte'>
                <div className='sec_next_cont'>
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere eigenen Projekte</h2>
                        <p>
                            Neben den Kundenprojekten entwickeln wir auch eigenständige Projekte. Unsere Produkte richten sich sowohl an Privatpersonen, als auch Unternehmen.<br />
                            Das Ziel dieser Projekte ist dabei nicht nur das Anbieten von SaaS-Plattformen, sondern auch die Weiterentcklung von modernen Technologien in neuen Geschäftsfeldern.
                        </p>
                    </motion.div>

                    <div>
                        {/* Projekt Vorschau */}

                    </div>
                    <br />
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <CTAButton className="" showArrow={false} customIcon={faList} iconLeft={true} title={"Entdecke alle Projekte"} href={'/projects/?type=projects'}></CTAButton>
                    </motion.div>
                </div>
            </section>
            <section className='sec_next' id='sec_next--home--commitment'>
                <div className='sec_next_cont'>
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unser Selbstverständnis</h2>
                        <p>
                            Wir möchten jederzeit State-of-the-art-Technologien und Lösungen entwickeln und anbieten. <br />
                            Hierfür setzen wir auf kontinuierliche Weiterbildung und einen starken Austausch mit Experten aus den verschiedenen Branchen<br />
                            Der Fokus bei unserer Arbeit steht dabei in erster Linie auf Nachhaltigkeit und Sozialem Engagegment - der Spaß darf aber natürlich auch nicht zu kurz kommen.<br />
                            Wir stehen für Offenheit und Toleranz - sowohl intern, als auch in der Kommunikation nach außen. Erfahre mehr zu <a href='/rechtliches/diversity'>Diversity bei ToN</a>.<br />
                            Aus diesem Grund unterstützen wir gerne soziale Projekte und Initiativen. Melde dich am besten gleich bei uns mit deiner Idee oder deinem Verein.<br />
                            Zudem setzen wir primär auf Open-Source und eigene Software, in Kombination mit eigenen in Deutschland gehosteten Servern.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={false} customIcon={faPeopleGroup} iconLeft={true} title={"Erfahre mehr über uns"} href={'/about'}></CTAButton>
                    </motion.div>
                </div>
            </section>
            <section className='sec_next' id='sec_next--home--partners'>
                <div className='sec_next_cont'>
                    <motion.div variants={motionVar1} className='' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <h2>Unsere Partner</h2>
                        <p>
                            Nur zusammen kann man Großes erreichen. Gemeinsam mit unseren Partnern schaffen wir das.<br />
                        </p>
                        <br />
                        <ul>
                            <li><a href='https://liepert.de' target='_blank' rel='noopener noreferrer'><b>it.liepert.gmbh</b></a>: IT-Systemhaus für maßgeschneiderte IT-Lösungen</li>
                            <li><a href='https://www.zeitgeist-politics.com/' target='_blank' rel='noopener noreferrer'><b>Adrian Schimmelpfennig Campaigning</b></a>: Socialmedia-Marketing und Videoproduktion</li>
                            <li><a href='https://prepaid-hoster.de' target='_blank' rel='noopener noreferrer'><b>PPH - Henrik Kramer e.K.</b></a>: Domain- und Hostingpartner in Deutschland</li>
                        </ul>
                    </motion.div>
                </div>
            </section>

            <br /><br /><br />
            <br /><br /><br />

            <MainFooter />
        </div >
    )
}